const usuario = JSON.parse(localStorage.getItem('user'));

 export const menuItems = 
 
 usuario.role == 1 ? [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.dashboards.badge",
    // },
    subItems: [
      {
        id: 3,
        label: "menuitems.dashboards.list.principal",
        link: "/",
        parentId: 2,
      },
    ],
  },
  {
    id: 7,
    isLayout: true,
  },
  {
    id: 8,
    label: "menuitems.apps.text",
    isTitle: true,
  },
  {
    id: 12,
    label: "menuitems.inventario.text",
    icon: "bx-store",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.inventario.badge",
    // },
    subItems: [
       {
                id: 13,
                label: "menuitems.inventario.list.tiendas",
                link: "/inventario/tiendas",
                parentId: 12
            }, 
      {
        id: 14,
        label: "menuitems.inventario.list.bodegas",
        link: "/inventario/bodegas",
        parentId: 12,
      } ,
            
          
            {
              id: 38,
              label: "menuitems.inventario.list.autos",
              link: "/inventario/autos",
              parentId: 12,
            },
      // {
      //   id: 17,
      //   label: "menuitems.inventario.list.unidades",
      //   link: "/inventario/unidades",
      //   parentId: 12,
      // },
      
      /*  {
                id: 19,
                label: "menuitems.inventario.list.servicios",
                link: "/inventario/servicios",
                parentId: 15
            }, */
      /*  {
                id: 20,
                label: "menuitems.inventario.list.gastosinternos",
                link: "/inventario/gastosinternos",
                parentId: 16
            }, */
    ],
  },
   // Productos
   {
    id: 122,
    label: "menuitems.productos.text",
    icon: "bx bxl-dropbox",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.productos.badge",
    // },
    subItems: [
      {
        id: 15,
        label: "menuitems.inventario.list.categoria",
        link: "/inventario/categoria",
        parentId: 12
      }, 
      {
        id: 17,
        label: "menuitems.ventas-menu.list.servicios",
        link: "/ventas/servicio",
        parentId: 14,
      },
      {
        id: 16,
        label: "menuitems.inventario.list.marcas",
        link: "/inventario/marcas",
        parentId: 12
    }, 
      {
        id: 18,
        label: "menuitems.inventario.list.productos",
        link: "/inventario/productos",
        parentId: 14,
      },
      {
        id: 18,
        label: "menuitems.inventario.list.traslados",
        link: "/inventario/traslados",
        parentId: 14,
      },
      /*  {
                id: 19,
                label: "menuitems.inventario.list.servicios",
                link: "/inventario/servicios",
                parentId: 15
            }, */
      /*  {
                id: 20,
                label: "menuitems.inventario.list.gastosinternos",
                link: "/inventario/gastosinternos",
                parentId: 16
            }, */
    ],
  },
  //Compras
  {
    id: 34,
    label: "menuitems.compras.principal",
    icon: "bx bx-shopping-bag",
    subItems: [
      {
        id: 35,
        label: "menuitems.compras.list.proveedor",
        link: "/compras/proveedor",
        parentId: 28,
      },

      // {
      //   id: 36,
      //   label: "menuitems.compras.list.ordendecompra",
      //   link: "/compras/ordendecompra",
      //   parentId: 29,
      // },

      {
        id: 37,
        label: "menuitems.compras.list.compras",
        link: "/compras/compras",
        parentId: 29,
      },
      {
        id: 35,
        label: "menuitems.compras.list.credito",
        link: "/compras/credito",
        parentId: 28,
      },
    ],
  },
  // Ventas
  {
    id: 2000,
    label: "menuitems.ventas-menu.principal",
    icon: "bx bx-shopping-bag",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.ventas-menu.badge",
    // },
    subItems: [
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.descuentos",
        link: "/ventas/descuentos",
        parentId: 2000,
      },
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.clientes",
        link: "/ventas/cliente",
        parentId: 2000,
      },
      // {
      //   id: 2004,
      //   label: "menuitems.ventas-menu.list.dias-vencimiento",
      //   link: "/ventas/dias-vencimiento",
      //   parentId: 2000,
      // },
      // {
      //   id: 2005,
      //   label: "menuitems.ventas-menu.list.cotizacion",
      //   link: "/ventas/cotizacion",
      //   parentId: 2000,
      // },
      {
        id: 2006,
        label: "menuitems.ventas-menu.list.ventas",
        link: "/ventas/venta",
        parentId: 2000,
      },
      {
        id: 2007,
        label: "menuitems.ventas-menu.list.creditos",
        link: "/ventas/creditos-venta",
        parentId: 2000,
      },
      {
        id: 2008,
        label: "menuitems.ventas-menu.list.abonar-cuenta",
        link: "/ventas/abonar-cuenta",
        parentId: 2000,
      },
      {
        id: 2010,
        label: "menuitems.ventas-menu.list.taller",
        link: "/ventas/taller",
        parentId: 2000,
      },
      {
        id: 2015,
        label: "menuitems.ventas-menu.list.credito-taller",
        link: "/ventas/creditos-taller",
        parentId: 2000,
      },
      // {
      //   id: 2007,
      //   label: "menuitems.ventas-menu.list.creditos",
      //   link: "/ventas/venta",
      //   parentId: 2000,
      // },
    ],
  },
  // Caja
  {
    id: 26,
    label: "menuitems.caja.principal",
    icon: "bx-store",
    subItems: [
      // {
      //   id: 27,
      //   label: "menuitems.caja.list.procesarVenta",
      //   link: "/caja/procesarVenta",
      //   parentId: 26,
      // },
      {
        id: 28,
        label: "menuitems.caja.list.inicio",
        link: "/caja/inicioCaja",
        parentId: 26,
      },
      // {
      //   id: 29,
      //   label: "menuitems.caja.list.corte",
      //   link: "/caja/corteCaja",
      //   parentId: 26,
      // },
    ],
  },
 
  // GASTOS
  {
    id: 45,
    label: "menuitems.gastos.text",
    icon: "bx-wallet",
    subItems: [
      // {
      //   id: 27,
      //   label: "menuitems.caja.list.procesarVenta",
      //   link: "/caja/procesarVenta",
      //   parentId: 26,
      // },
      {
        id: 28,
        label: "menuitems.gastos.list.tipo_gasto",
        link: "/gastos/tipo_gasto",
        parentId: 26,
      },
      {
        id: 28,
        label: "menuitems.gastos.list.gastos",
        link: "/gastos/gastos",
        parentId: 26,
      },
      // {
      //   id: 29,
      //   label: "menuitems.caja.list.corte",
      //   link: "/caja/corteCaja",
      //   parentId: 26,
      // },
    ],
  },
  {
    id: 21,
    label: "menuitems.administracion.text",
    icon: "bx-cog",
    subItems: [
      {
        id: 22,
        label: "menuitems.administracion.list.empleados",
        link: "/administracion/empleados",
        parentId: 18,
      },
      // {
      //     id: 23,
      //     label: "menuitems.administracion.list.proveedores",
      //     link: "/administracion/proveedores",
      //     parentId: 19
      // },
      // {
      //     id: 24,
      //     label: "menuitems.administracion.list.usuarios_especiales",
      //     link: "/administracion/usuarios_especiales",
      //     parentId: 20
      // },
      {
        id: 25,
        label: "menuitems.administracion.list.usuarios",
        link: "/administracion/usuarios",
        parentId: 21,
      },
      {
        id: 25,
        label: "menuitems.administracion.list.ganancias",
        link: "/administracion/ganancias",
        parentId: 21,
      },
    ],
  },
  // {
  //   id: 2612,
  //   label: "menuitems.reportes.text",
  //   icon: "bx-file",
  //   subItems: [
  //     {
  //       id: 27,
  //       label: "menuitems.reportes.list.departamento",
  //       link: "/reportes/departamento",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 28,
  //       label: "menuitems.reportes.list.ventas",
  //       link: "/reportes/ventas",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 27,
  //       label: "menuitems.reportes.list.clientesf",
  //       link: "/reportes/clientesf",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 28,
  //       label: "menuitems.reportes.list.existenciap",
  //       link: "/reportes/existenciap",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 27,
  //       label: "menuitems.reportes.list.clientes",
  //       link: "/reportes/clientes",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 28,
  //       label: "menuitems.reportes.list.compras",
  //       link: "/reportes/compras",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 27,
  //       label: "menuitems.reportes.list.cardex",
  //       link: "/reportes/cardex",
  //       parentId: 2612,
  //     },
  //     {
  //       id: 28,
  //       label: "menuitems.reportes.list.cortecaja",
  //       link: "/reportes/cortecaja",
  //       parentId: 2612,
  //     },
  //   ],
  // },
] : usuario.role == 2 ? [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.dashboards.badge",
    // },
    subItems: [
      {
        id: 3,
        label: "menuitems.dashboards.list.principal",
        link: "/",
        parentId: 2,
      },
    ],
  },
  {
    id: 7,
    isLayout: true,
  },
  {
    id: 8,
    label: "menuitems.apps.text",
    isTitle: true,
  },
  {
    id: 12,
    label: "menuitems.inventario.text",
    icon: "bx-store",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.inventario.badge",
    // },
    subItems: [
      
      {
        id: 14,
        label: "menuitems.inventario.list.bodegas",
        link: "/inventario/bodegas",
        parentId: 12,
      } ,
            
          
            {
              id: 38,
              label: "menuitems.inventario.list.autos",
              link: "/inventario/autos",
              parentId: 12,
            },
      // {
      //   id: 17,
      //   label: "menuitems.inventario.list.unidades",
      //   link: "/inventario/unidades",
      //   parentId: 12,
      // },
      
      /*  {
                id: 19,
                label: "menuitems.inventario.list.servicios",
                link: "/inventario/servicios",
                parentId: 15
            }, */
      /*  {
                id: 20,
                label: "menuitems.inventario.list.gastosinternos",
                link: "/inventario/gastosinternos",
                parentId: 16
            }, */
    ],
  },
   // Productos
   {
    id: 122,
    label: "menuitems.productos.text",
    icon: "bx bxl-dropbox",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.productos.badge",
    // },
    subItems: [
      {
        id: 15,
        label: "menuitems.inventario.list.categoria",
        link: "/inventario/categoria",
        parentId: 12
      }, 
      {
        id: 17,
        label: "menuitems.ventas-menu.list.servicios",
        link: "/ventas/servicio",
        parentId: 14,
      },
      {
        id: 16,
        label: "menuitems.inventario.list.marcas",
        link: "/inventario/marcas",
        parentId: 12
    }, 
      {
        id: 18,
        label: "menuitems.inventario.list.productos",
        link: "/inventario/productos",
        parentId: 14,
      },
      {
        id: 18,
        label: "menuitems.inventario.list.traslados",
        link: "/inventario/traslados",
        parentId: 14,
      },
   
    ],
  },
   // GASTOS
   {
    id: 45,
    label: "menuitems.gastos.text",
    icon: "bx-wallet",
    subItems: [
      // {
      //   id: 27,
      //   label: "menuitems.caja.list.procesarVenta",
      //   link: "/caja/procesarVenta",
      //   parentId: 26,
      // },
      {
        id: 28,
        label: "menuitems.gastos.list.tipo_gasto",
        link: "/gastos/tipo_gasto",
        parentId: 26,
      },
      {
        id: 28,
        label: "menuitems.gastos.list.gastos",
        link: "/gastos/gastos",
        parentId: 26,
      },
      // {
      //   id: 29,
      //   label: "menuitems.caja.list.corte",
      //   link: "/caja/corteCaja",
      //   parentId: 26,
      // },
    ],
  },
  //Compras
  {
    id: 34,
    label: "menuitems.compras.principal",
    icon: "bx bx-shopping-bag",
    subItems: [
      {
        id: 35,
        label: "menuitems.compras.list.proveedor",
        link: "/compras/proveedor",
        parentId: 28,
      },
      {
        id: 37,
        label: "menuitems.compras.list.compras",
        link: "/compras/compras",
        parentId: 29,
      },
      {
        id: 35,
        label: "menuitems.compras.list.credito",
        link: "/compras/credito",
        parentId: 28,
      },
    ],
  },
  // Ventas
  {
    id: 2000,
    label: "menuitems.ventas-menu.principal",
    icon: "bx bx-shopping-bag",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.ventas-menu.badge",
    // },
    subItems: [
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.descuentos",
        link: "/ventas/descuentos",
        parentId: 2000,
      },
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.clientes",
        link: "/ventas/cliente",
        parentId: 2000,
      },
    
      {
        id: 2006,
        label: "menuitems.ventas-menu.list.ventas",
        link: "/ventas/venta",
        parentId: 2000,
      },
      {
        id: 2007,
        label: "menuitems.ventas-menu.list.creditos",
        link: "/ventas/creditos-venta",
        parentId: 2000,
      },
      {
        id: 2008,
        label: "menuitems.ventas-menu.list.abonar-cuenta",
        link: "/ventas/abonar-cuenta",
        parentId: 2000,
      },
      {
        id: 2010,
        label: "menuitems.ventas-menu.list.taller",
        link: "/ventas/taller",
        parentId: 2000,
      },
      {
        id: 2015,
        label: "menuitems.ventas-menu.list.credito-taller",
        link: "/ventas/creditos-taller",
        parentId: 2000,
      },
    
      // {
      //   id: 2007,
      //   label: "menuitems.ventas-menu.list.creditos",
      //   link: "/ventas/venta",
      //   parentId: 2000,
      // },
    ],
  },
  // Caja
  {
    id: 26,
    label: "menuitems.caja.principal",
    icon: "bx-store",
    subItems: [
      // {
      //   id: 27,
      //   label: "menuitems.caja.list.procesarVenta",
      //   link: "/caja/procesarVenta",
      //   parentId: 26,
      // },
      {
        id: 28,
        label: "menuitems.caja.list.inicio",
        link: "/caja/inicioCaja",
        parentId: 26,
      },
      // {
      //   id: 29,
      //   label: "menuitems.caja.list.corte",
      //   link: "/caja/corteCaja",
      //   parentId: 26,
      // },
    ],
  },
 
 
  ] :
  usuario.role == 3 ? [
    {
      id: 1,
      label: "menuitems.menu.text",
      isTitle: true,
    },
    {
      id: 2,
      label: "menuitems.dashboards.text",
      icon: "bx-home-circle",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.dashboards.badge",
      // },
      subItems: [
        {
          id: 3,
          label: "menuitems.dashboards.list.principal",
          link: "/",
          parentId: 2,
        },
      ],
    },
    {
      id: 7,
      isLayout: true,
    },
    {
      id: 8,
      label: "menuitems.apps.text",
      isTitle: true,
    },
    {
      id: 12,
      label: "menuitems.inventario.text",
      icon: "bx-store",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.inventario.badge",
      // },
      subItems: [
    
      
              
            
              {
                id: 38,
                label: "menuitems.inventario.list.autos",
                link: "/inventario/autos",
                parentId: 12,
              },
     
      ],
    },
     // Productos
     {
      id: 122,
      label: "menuitems.productos.text",
      icon: "bx bxl-dropbox",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.productos.badge",
      // },
      subItems: [
    
        {
          id: 17,
          label: "menuitems.ventas-menu.list.servicios",
          link: "/ventas/servicio",
          parentId: 14,
        },
     
      ],
    },
  
    // Ventas
    {
      id: 2000,
      label: "menuitems.ventas-menu.principal",
      icon: "bx bx-shopping-bag",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.ventas-menu.badge",
      // },
      subItems: [
        {
          id: 2001,
          label: "menuitems.ventas-menu.list.clientes",
          link: "/ventas/cliente",
          parentId: 2000,
        },
       
        {
          id: 2010,
          label: "menuitems.ventas-menu.list.taller",
          link: "/ventas/taller",
          parentId: 2000,
        },
        {
          id: 2015,
          label: "menuitems.ventas-menu.list.credito-taller",
          link: "/ventas/creditos-taller",
          parentId: 2000,
        },
      ],
    },
    // Caja
    {
      id: 26,
      label: "menuitems.caja.principal",
      icon: "bx-store",
      subItems: [
        // {
        //   id: 27,
        //   label: "menuitems.caja.list.procesarVenta",
        //   link: "/caja/procesarVenta",
        //   parentId: 26,
        // },
        {
          id: 28,
          label: "menuitems.caja.list.inicio",
          link: "/caja/inicioCaja",
          parentId: 26,
        },
        // {
        //   id: 29,
        //   label: "menuitems.caja.list.corte",
        //   link: "/caja/corteCaja",
        //   parentId: 26,
        // },
      ],
    },
   
  ]:

[];

